import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import { useMediaQuery, Container, Grid, TAGTypography, TAGCarousel, useTheme, Box } from '../..';
import Card from './Card';

var MultiCard = function MultiCard(_ref) {
  var backgroundColor = _ref.backgroundColor,
      _ref$bigScreenBackgro = _ref.bigScreenBackground,
      bigScreenBackground = _ref$bigScreenBackgro === void 0 ? false : _ref$bigScreenBackgro,
      branding = _ref.branding,
      cards = _ref.cards,
      _ref$cardsAlignment = _ref.cardsAlignment,
      cardsAlignment = _ref$cardsAlignment === void 0 ? 'center' : _ref$cardsAlignment,
      description = _ref.description,
      _ref$eyebrowColor = _ref.eyebrowColor,
      eyebrowColor = _ref$eyebrowColor === void 0 ? 'text.secondary' : _ref$eyebrowColor,
      eyebrowTextTransform = _ref.eyebrowTextTransform,
      _ref$forMobile = _ref.forMobile,
      forMobile = _ref$forMobile === void 0 ? 'carousel' : _ref$forMobile,
      _ref$roundedImage = _ref.roundedImage,
      roundedImage = _ref$roundedImage === void 0 ? true : _ref$roundedImage,
      sectionEyebrow = _ref.sectionEyebrow,
      _ref$sectionInfoAlign = _ref.sectionInfoAlignment,
      sectionInfoAlignment = _ref$sectionInfoAlign === void 0 ? 'center' : _ref$sectionInfoAlign,
      sectionTitle = _ref.sectionTitle;
  var mobileWidth = useMediaQuery('(max-width:600px)');
  var tabletWidth = useMediaQuery('(max-width:900px)');
  var desktopWidth = useMediaQuery('(min-width:900px)');
  var theme = useTheme();

  var getColumns = function getColumns(cards) {
    if (cards.length === 1) {
      return 'repeat(1, 32.33%)';
    } else if (cards.length === 2 || cards.length === 4) {
      return cardsAlignment === 'flex-start' ? 'repeat(3, 32.33%)' : 'repeat(2, 33.33%)';
    } else if (cards.length === 3) {
      return 'repeat(3, 32.33%)';
    } else if (cards.length > 4) {
      return 'repeat(3, 32.33%)';
    } else {
      return "repeat(".concat(cards.length, ", ").concat(100 / cards.length, "%)");
    }
  };

  var renderCards = function renderCards() {
    return cards.map(function (card, index) {
      return React.createElement(Grid, {
        item: true,
        key: card.id,
        sx: {
          height: '100%',
          width: '100%'
        }
      }, React.createElement(Card, {
        key: index,
        branding: branding,
        card: card,
        itemStacked: forMobile === 'stack',
        roundedImage: roundedImage,
        eyebrowColor: eyebrowColor,
        eyebrowTextTransform: eyebrowTextTransform,
        allCards: cards
      }));
    });
  };

  return React.createElement(Grid, {
    sx: mobileWidth || desktopWidth && bigScreenBackground ? {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      padding: '40px 0'
    } : {
      padding: '40px 0'
    }
  }, (sectionTitle || sectionEyebrow || (description === null || description === void 0 ? void 0 : description.description)) && React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: sectionInfoAlignment,
    alignItems: sectionInfoAlignment,
    textAlign: sectionInfoAlignment === 'center' ? 'center' : 'start',
    spacing: 2,
    sx: {
      marginBottom: '40px'
    }
  }, sectionEyebrow && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.secondary',
    variant: mobileWidth ? 'bodySmallBook' : 'bodyMediumBook'
  }, sectionEyebrow)), sectionTitle && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.primary',
    variant: "h1"
  }, sectionTitle)), (description === null || description === void 0 ? void 0 : description.description) && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.secondary',
    variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
    sx: {
      display: 'flex',
      textAlign: sectionInfoAlignment === 'center' ? 'center' : 'start'
    }
  }, description.description)))), React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    spacing: 2,
    sx: _defineProperty({
      display: 'flex',
      justifyContent: cardsAlignment
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column'
    })
  }, !tabletWidth ? React.createElement(Box, {
    sx: {
      display: 'grid',
      gap: '16px',
      gridTemplateColumns: getColumns(cards),
      justifyContent: cardsAlignment,
      alignItems: cardsAlignment,
      width: '100%',
      padding: '0 16px'
    }
  }, renderCards()) : forMobile === 'carousel' ? cards.length > 1 ? React.createElement(TAGCarousel, {
    peeking: mobileWidth,
    sx: {
      minWidth: cards.length > 2 ? {
        sm: '100%',
        xs: '100%',
        md: '100%',
        lg: '100%'
      } : {
        sm: '100%',
        xs: '100%',
        md: '66%',
        lg: '66%'
      },
      flex: 1,
      flexBasis: '100%',
      '& .react-swipeable-view-container': {
        width: cards.length > 2 ? {
          xs: '100%',
          sm: '50%',
          md: '33.33%',
          lg: '33.33%'
        } : {
          xs: '100%',
          sm: '50%',
          md: '50%',
          lg: '50%'
        }
      },
      disabled: true
    }
  }, renderCards()) : React.createElement(Card, {
    card: cards[0],
    branding: branding,
    roundedImage: roundedImage,
    eyebrowColor: eyebrowColor,
    eyebrowTextTransform: eyebrowTextTransform,
    allCards: cards
  }) : React.createElement(React.Fragment, null, renderCards()))));
};

export default MultiCard;